import * as Select from '@radix-ui/react-select';
import { UsersOrderByEnum } from 'api/user/user.api';
import { FaChevronDown } from 'react-icons/fa';

type SelectOrderByProps = {
  orderBy: UsersOrderByEnum;
  setOrderBy: React.Dispatch<React.SetStateAction<UsersOrderByEnum>>;
};

const options: { label: string; value: UsersOrderByEnum }[] = [
  { label: 'followers count', value: 'followersCount' },
  { label: 'items count', value: 'itemsCount' },
];

const SelectOrderBy = ({ orderBy, setOrderBy }: SelectOrderByProps) => {
  return (
    <Select.Root
      onValueChange={(value: UsersOrderByEnum) => {
        setOrderBy(value);
      }}
      value={orderBy}
      aria-label="Select order by"
    >
      <Select.Trigger className="text-blue-21 outline-0 ml-3">
        <Select.Value placeholder={orderBy} />
        <Select.Icon>
          <FaChevronDown size={16} className="inline ml-2" />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content>
          <Select.Viewport className="p-2 bg-amber-f8 rounded-md shadow-lg">
            {options.map((option) => (
              <Select.Item
                className="text-base xs:text-lg md:text-2xl cursor-pointer text-blue-21 font-extrabold"
                key={option.value}
                value={option.value}
              >
                <Select.ItemText>{option.label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

export default SelectOrderBy;
